import {Component,OnInit} from "@angular/core";
import {ListView,TypeComparaison,TypeFilter} from "@domain/common/list-view";
import {BehaviorSubject} from "rxjs";
import {FloatingButtonAction,TypeAction} from "@share/component/floating-button/floating-button";
import {CompteApi} from "@domain/admin/parametre/api/compte-api";
import {ApiRestListItemComponent} from "@components/admin/parametre/api/rest/api-rest-list-item/api-rest-list-item.component";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";
import {environment} from "@environments/environment";

/**
 * Onglet API REST
 *
 * @author Guillaume TRAVOT
 * @date 21/11/2023
 */
@Component({
    host: {'data-test-id': 'api-rest'},
    templateUrl: './api-rest.component.html'
})
export class ApiRestComponent implements OnInit {
    /** Liste des comptes API */
    listeCompte: ListView<CompteApi,ApiRestListItemComponent>;

    /** Liste des actions possibles */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

    /**
     * Constructeur
     */
    constructor(private translateService: TranslateService,private router: Router) {}

    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        //Initialisation de la liste
        this.listeCompte = new ListView<CompteApi,ApiRestListItemComponent>({
            uri: '/controller/CompteAPI/listeCompteApi',
            title: this.translateService.instant('admin.parametres.api.rest.liste.title'),
            component: ApiRestListItemComponent,
            defaultOrder: 'comptePersonnel,identifiant',
            listeFilters: [{
                title: this.translateService.instant("admin.parametres.api.rest.liste.identifiant"),
                clef: "identifiant",
                isDefault: true,
                typeComparaison: TypeComparaison[TypeComparaison.LIKE]
            },{
                title: this.translateService.instant("admin.parametres.api.rest.liste.email"),
                clef: "email",
                isDefault: true,
                typeComparaison: TypeComparaison[TypeComparaison.LIKE]
            },{
                clef: 'derniereConnexion',
                title: this.translateService.instant('admin.parametres.api.rest.liste.derniereConnexion'),
                isDefault: false,
                type: TypeFilter[TypeFilter.DATE]
            },{
                clef: 'dateCloture',
                title: this.translateService.instant('admin.parametres.api.rest.liste.dateCloture'),
                isDefault: false,
                type: TypeFilter[TypeFilter.DATE]
            },{
                clef: 'actif',
                title: this.translateService.instant('admin.parametres.api.rest.liste.actif'),
                isDefault: false,
                listeValues: [{
                    code: 'true',
                    libelle: this.translateService.instant('filter.valeurOuiNon.true')
                }, {
                    code: 'false',
                    libelle: this.translateService.instant('filter.valeurOuiNon.false')
                }],
                type: TypeFilter[TypeFilter.BOOLEAN],
                typeComparaison: TypeComparaison[TypeComparaison.EQUAL],
            },{
                clef: 'verrouille',
                title: this.translateService.instant('admin.parametres.api.rest.liste.verrouille'),
                isDefault: false,
                listeValues: [{
                    code: 'true',
                    libelle: this.translateService.instant('filter.valeurOuiNon.true')
                }, {
                    code: 'false',
                    libelle: this.translateService.instant('filter.valeurOuiNon.false')
                }],
                type: TypeFilter[TypeFilter.BOOLEAN],
                typeComparaison: TypeComparaison[TypeComparaison.EQUAL],
            }]
        });

        //Définition des colonnes de tri
        this.listeCompte.columns = [
            { key: 'identifiant', title: 'admin.parametres.api.rest.liste.identifiant' },
            { key: 'email', title: 'admin.parametres.api.rest.liste.email' },
            { key: 'derniereConnexion', title: 'admin.parametres.api.rest.liste.derniereConnexion' },
            { key: 'dateCloture', title: 'admin.parametres.api.rest.liste.dateCloture' }
        ];

        //Persistance des filtres
        this.listeCompte.isPersistFilters = true;
        this.listeCompte.className = 'ApiRestComponent';

        //Ajout des actions possibles
        this.listeActions.next([
            {
                type: TypeAction.PRIMARY,
                icone: 'nio icon-ajouter',
                libelle: 'global.actions.creer',
                doAction: () => this.navigateToCreation()
            },{
                type: TypeAction.SECONDARY,
                icone: 'material-icons-outlined',
                iconeName: 'assignment_turned_in',
                libelle: 'admin.parametres.api.rest.liste.tester',
                doAction: () => this.navigateToSwagger()
            }
        ]);
    }

    /**
     * Navigation vers le Swagger
     */
    navigateToSwagger(): void {
        //URL du Swagger
        let callSwagger = `${environment.baseUrl}/api/swagger-ui/index.html`;

        //Ouverture du Swagger dans une nouvelle fenêtre
        window.open(callSwagger, '_blank');
    }

    /**
     * Création d'un compte API
     */
    navigateToCreation(): void {
        //Navigation vers une page de détails vierge
        this.router.navigate([`Admin/Parametre/API/Rest/0`]);
    }
}